export const typeOptions = {
  1: '穿越',
  2: '奇幻',
  3: '推理',
  4: '搞笑',
  5: '校园',
  6: '日常',
  7: '热血',
  8: '战斗',
}
